































import { Component, Mixins } from 'vue-property-decorator'
import { ITutorialSlide } from '@/components/Tutorial.vue'
import { LibraryMixin } from '@/mixins'
import { SPOTIFY_PLAYLIST_REGEX } from '@/constants'

@Component({
  components: {
    IconCard: require('@/components/IconCard').default,
    Tutorial: require('@/components/Tutorial').default,
    Tip: require('@/components/Tip').default
  }
})
export default class DiscoveryChoice extends Mixins(LibraryMixin) {
  tutorialSlides: ITutorialSlide[] = []

  async onSpotifyDragdrop(e: DragEvent) {
    e.stopPropagation()
    e.preventDefault()

    if (e.dataTransfer) {
      const text = e.dataTransfer.getData('text/plain')

      if (text && SPOTIFY_PLAYLIST_REGEX.test(text)) {
        await this.$router.push({
          name: 'discovery spotify',
          query: {
            playlistLink: text
          }
        })
      }
    }
  }
}
